// extracted by mini-css-extract-plugin
export var label = "_kn-2";
export var slideContainer = "_kn-0";
export var slider = "_kn-1";